import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CoreModule } from './../core/core.module';
import { TrialGuardService } from '../core';
import {
  RentalAssetBaseComponent,
  RentalAssetsComponent,
  RentalAssetComponent,
  RentalAssetDashboardComponent,
  RentalAssetService,
  SelectedAssetService,
} from './index';
import { CollapsibleComponent } from '@/app/equipment/components/collapsible.component';
import { LastSavedTimeComponent } from './last-saved-time.component';
import { SavedViewsComponent } from '@/app/modules/saved-views/saved-views/saved-views.component';
import { SavedViewsModule } from '@/app/modules/saved-views/saved-views.module';
import { FeatureFlagModule } from '@/app/core/feature-flags/feature-flag.module';

const root = 'rental-assets';
const rentalAssetRoutes: Routes = [
  {
    path: root,
    component: RentalAssetsComponent,
    data: { title: 'main.tabs.equipment.rental_assets.page_titles.root' },
    canActivate: [TrialGuardService],
  },
  {
    path: root + '/:asset',
    component: RentalAssetComponent,
    canActivate: [TrialGuardService],
    children: [
      {
        path: '',
        component: RentalAssetDashboardComponent,
        data: {
          name: 'dashboard',
          title: 'main.tabs.equipment.rental_assets.page_titles.dashboard',
        },
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(rentalAssetRoutes),
    CommonModule,
    CoreModule,
    InfiniteScrollModule,
    CollapsibleComponent,
    SavedViewsComponent,
    LastSavedTimeComponent,
    SavedViewsModule,
    SavedViewsComponent,
    FeatureFlagModule,
  ],
  declarations: [
    RentalAssetBaseComponent,
    RentalAssetsComponent,
    RentalAssetComponent,
    RentalAssetDashboardComponent,
  ],
  providers: [RentalAssetService, SelectedAssetService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class RentalAssetsModule {}
